import API from './API';
import moment from 'moment';

const GraphFuncs = {

    isEmpty: (obj) => {
        if (obj == null) return true;
        return Object.keys(obj).length === 0;
    },

    formatSeriesByTimestamp: (data, channel, vpf = false) => {
        var serieArray = {}
        if (!GraphFuncs.isEmpty(data)) {
            for (let obj of data) {
                if (!GraphFuncs.isEmpty(obj)) {
                    if (vpf !== false) {
                        let sumA = 0
                        let sumPf = 0
                        for (let channel of vpf) {
                            sumA += parseFloat(obj[`channel_${channel.channel}_a`])
                        }
                        for (let channel of vpf) {
                            let tempSum = sumA ? (parseFloat(obj[`channel_${channel.channel}_a`]) * parseFloat(obj[`channel_${channel.channel}_pf`])) / sumA : 1
                            sumPf += tempSum
                        }
                        serieArray[obj["timestamp"]] = { amp: sumA, pf: sumPf }
                    } else {
                        serieArray[obj["timestamp"]] = parseFloat(obj[channel])
                    }
                }
            }
        }
        return serieArray
    },
    formatSeriesByTimestampD: (data) => {
        var serieArray = {}
        if (!GraphFuncs.isEmpty(data)) {
            for (let obj of data) {
                if (!GraphFuncs.isEmpty(obj)) {
                    serieArray[obj["timestamp"]] = parseFloat(obj.value)
                }
            }
        }
        return serieArray
    },
    getDifferenceInDays: (date1, date2) => {
        if (!date1 || !date2) return 0
        return moment(date2).diff(moment(date1), 'days') + 1
    },
    getDifferenceInMonths: (date1, date2) => {
        if (!date1 || !date2) return 0

        const start = moment(date1, 'YYYY-MM-DD');
        const lastDay = moment(date2, 'YYYY-MM-DD');
        let numMonths = (lastDay.year() - start.year()) * 12 + (lastDay.month() - start.month());
        if(lastDay.year() === start.year() || start <= lastDay) numMonths += 1
        
        return numMonths
    },
    findCirctuitInHierarchy: (circuit, hierarchy) => {
        for (const key in hierarchy) {
            if (key === circuit || (circuit === 'Main Distribution' && hierarchy[key].category === "Building Distribution")) {
                return JSON.parse(JSON.stringify(hierarchy[key]));
            } else if (Object.keys(hierarchy[key].children).length !== 0) {
                // If the value is another object (nested JSON), recursively call the function
                const nestedValue = GraphFuncs.findCirctuitInHierarchy(circuit, hierarchy[key].children);
                if (nestedValue !== undefined) {
                    return nestedValue; // If the key is found in the nested JSON, return its value
                }
            }
        }
    },
    findCirctuitInHierarchyD: (circuit, hierarchy) => {
        for (const key in hierarchy) {
            if (key.trim() === circuit.trim() || (circuit === 'Main Distribution' && hierarchy[key].category === "Building Level")) {
                return JSON.parse(JSON.stringify(hierarchy[key]));
            } else if (Object.keys(hierarchy[key].children).length !== 0) {
                // If the value is another object (nested JSON), recursively call the function
                const nestedValue = GraphFuncs.findCirctuitInHierarchyD(circuit, hierarchy[key].children);
                if (nestedValue !== undefined) {
                    return nestedValue; // If the key is found in the nested JSON, return its value
                }
            }
        }
    },
    getAllMeasuredChildren: (circuit) => {
        let channelsList = []
        for (const key in circuit.children) {
            if (!circuit.children[key].virtual) channelsList.push(JSON.parse(JSON.stringify(circuit.children[key])));
            else channelsList.push(...GraphFuncs.getAllMeasuredChildren(circuit.children[key]))
        }
        return channelsList
    },
    getAllMeasuredChildrenD: (circuit) => {
        let channelsList = []
        for (const key in circuit.children) {
            if (!circuit.children[key].virtual) channelsList.push(JSON.parse(JSON.stringify(circuit.children[key])));
            else channelsList.push(...GraphFuncs.getAllMeasuredChildrenD(circuit.children[key]))
        }
        return channelsList
    },
    getNonSubmonitored: (channels) => {
        let circuits = {}
        for (let channel of channels) {
            if (!channel.sub_monitored === null || (channel.sub_monitored && channel.sub_monitored.toLowerCase() !== "no")) continue
            if (channel.id in circuits) {
                circuits[channel.id].channels.push({ channel: channel.id, phase: channel.phase })
            } else {
                circuits[channel.id] = JSON.parse(JSON.stringify(channel))
                circuits[channel.id].channels = [{ channel: channel.id, phase: channel.phase }]
            }
        }
        return Object.values(circuits)
    },
    getPeakKva: async (cancelToken, circuit, start, end) => {
        circuit = JSON.parse(JSON.stringify(circuit));
        let res = await API.getElectricity(cancelToken, start, end, circuit.id, 15, 'kva')
        let maxKey = null;
        let maxValue = 0;
        let data = res.data.series
        for (const key in data) {
            if (data[key] > maxValue) {
                maxKey = key;
                maxValue = data[key];
            }
        }
        return { [maxKey]: maxValue }
    }    
}

export default GraphFuncs;



